import React from 'react';
import { ArrowUpIcon, ArrowDownIcon } from '@heroicons/react/24/outline';

interface StatsCardProps {
  title: string;
  value: number;
  changeText?: string;
  change?: number;
  icon: React.ReactNode;
}

const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  changeText,
  change,
  icon,
}) => {
  const isPositiveChange = change === undefined ? true : change > 0;

  return (
    <div className="stats-card hover:border-primary-500/20 group">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">
            {title}
          </p>
          <p className="text-2xl font-bold text-gray-900 dark:text-white">
            {value.toLocaleString()}
          </p>
          {(changeText || change !== undefined) && (
            <div className="mt-2 flex items-center text-sm">
              {change !== undefined ? (
                <>
                  {isPositiveChange ? (
                    <ArrowUpIcon className="h-4 w-4 text-primary-500 mr-1" />
                  ) : (
                    <ArrowDownIcon className="h-4 w-4 text-red-500 mr-1" />
                  )}
                  <span className={isPositiveChange ? 'text-primary-500' : 'text-red-500'}>
                    {change}%
                  </span>
                  <span className="ml-1 text-gray-500 dark:text-gray-400">
                    Increased by
                  </span>
                </>
              ) : (
                <span className="text-primary-500">
                  {changeText}
                </span>
              )}
            </div>
          )}
        </div>
        <div className="p-3 bg-light-hover dark:bg-dark-hover rounded-xl group-hover:bg-primary-500/10 dark:group-hover:bg-primary-500/20 transition-colors duration-200">
          {React.cloneElement(icon as React.ReactElement, {
            className: 'w-5 h-5 text-gray-400 dark:text-gray-500 group-hover:text-primary-500'
          })}
        </div>
      </div>
    </div>
  );
};

export default StatsCard;